import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import SupportPillars from "./sections/SupportPillars";
import WorkProcess from "./sections/WorkProcess";
import FaqSection from "./sections/FaqSection";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <SupportPillars />
      <WorkProcess />
      <FaqSection />
      <Footer />
    </div>;
}